import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import IconButton from 'components/common/buttons/IconButton';
import { Icon, Menu, MenuItem, styled } from '@mui/material';
import FlexBox from 'components/common/FlexBox';
import { Typography } from '@totalsoft/rocket-ui';
import { withPropsExclusion } from 'utils/functions';

const ActionIcon = styled(
  Icon,
  withPropsExclusion('disabled')
)(({ theme, disabled }) => ({
  color: disabled ? theme.palette.grey[500] : undefined
}));

const ActionTypography = styled(
  Typography,
  withPropsExclusion('disabled')
)(({ theme, disabled }) => ({
  color: disabled ? theme.palette.grey[500] : undefined
}));

const ListActionsMenu = ({ actions, disabled: globalDisabled }) => {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = useCallback(event => {
    setAnchorEl(event.target);
  }, []);

  const handleClose = useCallback(() => {
    setAnchorEl(null);
  }, []);

  return (
    <>
      <IconButton
        aria-controls='hierarchy-actions-menu'
        icon='more_horiz'
        tooltip={t('General.Actions')}
        disabled={globalDisabled}
        onClick={handleClick}
      />
      <Menu
        id='hierarchy-actions-menu'
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        onClose={handleClose}
      >
        {actions.map(({ label, caption, handler, icon, color = 'primary', disabled }, index) => {
          const actionDisabled = globalDisabled || disabled;

          return (
            <MenuItem
              key={index}
              onClick={() => {
                if (actionDisabled) return;
                handler();
                handleClose();
              }}
            >
              <FlexBox gap={1} alignItems='center'>
                <ActionIcon color={color} disabled={actionDisabled} fontSize='small'>
                  {icon}
                </ActionIcon>
                <ActionTypography color='textPrimary' disabled={actionDisabled} variant='body2'>
                  {caption ? t(caption) : label}
                </ActionTypography>
              </FlexBox>
            </MenuItem>
          );
        })}
      </Menu>
    </>
  );
};

ListActionsMenu.propTypes = {
  actions: PropTypes.arrayOf(PropTypes.shape({ label: PropTypes.string, caption: PropTypes.string, handler: PropTypes.func })),
  disabled: PropTypes.bool
};

export default ListActionsMenu;
